import { render, staticRenderFns } from "./LoyaltyForm.vue?vue&type=template&id=86a77044"
import script from "./LoyaltyForm.vue?vue&type=script&lang=ts"
export * from "./LoyaltyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports